import base64js from "base64-js";
import { TextDecoderLite } from "text-encoder-lite-module";

export default function decodeOverride(override) {
  //extracted from https://github.com/RGBboy/urlsafe-base64
  //with advice from https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_.232_.E2.80.93_rewriting_atob()_and_btoa()_using_TypedArrays_and_UTF-8

  // Add removed at end '='
  if (override.length % 4 !== 0) {
    override += new Array(5 - (override.length % 4)).join("=");
  }

  override = override
    .replace(/-/g, "+") // Convert '-' to '+'
    .replace(/_/g, "/"); // Convert '_' to '/'

  var uint8array = base64js.toByteArray(override);
  var json = new TextDecoderLite("utf-8").decode(uint8array);

  return JSON.parse(json);
}
